import React, { forwardRef, AnchorHTMLAttributes } from 'react';
// eslint-disable-next-line no-restricted-imports
import Link, { LinkProps } from 'next/link';
import { useFranchise } from '~/shared/utils';

type Props = Partial<LinkProps> & AnchorHTMLAttributes<HTMLAnchorElement>;

const isExternalLink = (href?: string) => {
    if (!href) return false;
    return /^(https?:)?\/\//.test(href);
};

const CMSLinkComponent = forwardRef<HTMLElement, Props>((props, ref) => {
    const { href, children, className, style, locale, onClick, prefetch, ...rest } = props;
    const { isMultiCultural } = useFranchise();

    if (href || onClick) {
        if (isExternalLink(href)) {
            // Render native anchor for external links
            return (
                <a
                    href={href}
                    className={className}
                    style={style}
                    ref={ref as React.Ref<HTMLAnchorElement>}
                    onClick={onClick}
                    target={rest.target || '_blank'}
                    rel={rest.rel || 'noopener noreferrer'}
                    {...rest}
                >
                    {children}
                </a>
            );
        }
        // Internal link
        return (
            <Link
                href={href || ''}
                className={className}
                {...(onClick && { onClick })}
                style={style}
                ref={ref as React.Ref<HTMLAnchorElement>}
                locale={isMultiCultural ? locale : false}
                prefetch={prefetch}
                {...rest}
            >
                {children}
            </Link>
        );
    }

    // if no href render as <div>
    return (
        <div className={className} style={style} ref={ref as React.Ref<HTMLDivElement>}>
            {children}
        </div>
    );
});

const CMSLink = React.memo(CMSLinkComponent);
CMSLink.displayName = 'CMSLink';

export { CMSLink };
